import { render, staticRenderFns } from "./NotifcationGroup.vue?vue&type=template&id=3728f7e4"
import script from "./NotifcationGroup.vue?vue&type=script&lang=js"
export * from "./NotifcationGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports